import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ShareContent } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ShareContentAction extends Action {
  content: IContentInfo;
}

export function shareContent(content: IContentInfo): ShareContentAction {
  return {
    type: ShareContent,
    content
  };
}

export const isShareAction = isActionFactory<ShareContentAction>(ShareContent);
